import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Chip,
  Box,
  CircularProgress,
} from '@mui/material';
import notificheApi from '../../api/notificheApi';
import { AuthContext } from '../../auth/AuthContext';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { formatDate } from '../../utils/dateFormatter';

export default function NotificheListPageDesktop() {
  const [notifiche, setNotifiche] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
    useEffect(() => {
      fetchNotifiche();
    }, []);


  const fetchNotifiche = async () => {
    setLoading(true);
    try {
      const r = await notificheApi.lista();
      console.log("notifiche",r);
      setNotifiche(r);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async (notifica) => {
    setLoading(true);
    try {
      if (!notifica.letta) {
        await notificheApi.markAsRead(notifica.id);
        await fetchNotifiche();
      }
      console.log("notifica",notifica);
      switch (notifica.tipoNotifica) {
        case 'DOCUMENTO_RICHIESTO':
          navigate(`/fascicolo/me`);
          break;
        case 'DOCUMENTO_CARICATO':
          notifica.contribuenteId && user.role!="CONTRIBUENTE"?navigate(`/fascicolo/contribuente/${notifica.contribuenteId}`):notifica.contribuenteId && user.role=="CONTRIBUENTE"?navigate(`/fascicolo/me`):null;
          break;
        case 'SCADENZA_IMMINENTE':
             navigate(`/scadenze/calendar?scadenza=${notifica.scadenzaId}`);
        default:
          console.warn('Tipo notifica non gestito:', notifica.tipoNotifica);
          break;
      }
    } catch (err) {
      console.error('Errore gestione notifica', err);
    } finally {
      setLoading(false);
    }
  };

  if (!notifiche) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
    <BackButtonDesktop />
      <Typography variant="h5" sx={{ mb: 3 }}>
        Notifiche
      </Typography>
      {notifiche.length === 0 ? (
        <Typography>Nessuna notifica</Typography>
      ) : (
        <List>
          {notifiche.map((n) => (
            <ListItem key={n.id} disablePadding>
              <ListItemButton onClick={() => handleClick(n)}>
                <ListItemText
                  primary={n.titolo}
                  secondary={"Inviata il:  "+formatDate(n.dataCreazione)+" Oggetto: "+n.messaggio}
                />
                {!n.letto && <Chip label="nuova" color="primary" size="small" />}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CircularProgress size={24} />
        </Box>
      )}
    </Container>
  );
}
